import React, { useState, useEffect, useCallback } from 'react';
import Layout from '../components/Layout';
import api from '../services/api';

const PLANTILLA_DEFAULT = `¡Hola {nombre}! 👋 Te escribimos de LinkUs Telecomunicaciones.

¿Sabías que ahora también tenemos tienda de tecnología con entrega en Santander de Quilichao y Caloto? 💻📱 Portátiles, redes, accesorios y más — con la misma confianza de tu proveedor de internet.

Mira el catálogo aquí: https://linkustelecom.com/tienda`;

const formatearTelefono = (tel) => {
  const solo = (tel || '').replace(/\D/g, '');
  if (!solo) return null;
  if (solo.length === 10) return '57' + solo;
  if (solo.length === 12 && solo.startsWith('57')) return solo;
  return solo.length >= 10 ? solo : null;
};

const aplicarPlantilla = (plantilla, cliente) => plantilla.replace(/\{nombre\}/g, (cliente.nombre || '').split(' ')[0]);

export default function Whatsapp() {
  const [clientes, setClientes] = useState([]);
  const [planes, setPlanes] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [buscar, setBuscar] = useState('');
  const [estado, setEstado] = useState('activo');
  const [planId, setPlanId] = useState('');
  const [plantilla, setPlantilla] = useState(PLANTILLA_DEFAULT);
  const [enviados, setEnviados] = useState({});

  const cargar = useCallback(async () => {
    setCargando(true);
    const params = new URLSearchParams();
    if (buscar) params.append('buscar', buscar);
    if (estado) params.append('estado', estado);
    if (planId) params.append('plan_id', planId);
    try {
      const { data } = await api.get(`/api/clientes?${params}`);
      setClientes(data);
    } catch (e) { setClientes([]); }
    setCargando(false);
  }, [buscar, estado, planId]);

  useEffect(() => { cargar(); }, [cargar]);
  useEffect(() => { api.get('/api/planes').then(r => setPlanes(r.data)).catch(() => {}); }, []);

  const conTelefono = clientes.filter(c => formatearTelefono(c.telefono));
  const sinTelefono = clientes.length - conTelefono.length;

  const enviar = (c) => {
    const tel = formatearTelefono(c.telefono);
    if (!tel) return;
    const mensaje = aplicarPlantilla(plantilla, c);
    window.open(`https://wa.me/${tel}?text=${encodeURIComponent(mensaje)}`, '_blank');
    setEnviados(p => ({ ...p, [c.id]: true }));
  };

  const reiniciarMarcados = () => setEnviados({});

  return (
    <Layout>
      <div style={s.header}>
        <div>
          <h1 style={s.titulo}>📲 WhatsApp asistido</h1>
          <p style={s.sub}>Escribe el mensaje una vez y envíalo a cada cliente con un clic — tú confirmas el envío en WhatsApp.</p>
        </div>
      </div>

      <div style={s.panel}>
        <label style={s.label}>Mensaje (usa <code>{'{nombre}'}</code> para que se reemplace por el primer nombre de cada cliente)</label>
        <textarea style={s.textarea} rows={6} value={plantilla} onChange={e => setPlantilla(e.target.value)} />
        {clientes[0] && (
          <div style={s.preview}>
            <div style={s.previewLabel}>Vista previa (primer resultado: {clientes[0].nombre})</div>
            <div style={s.previewTexto}>{aplicarPlantilla(plantilla, clientes[0])}</div>
          </div>
        )}
      </div>

      <div style={s.filtros}>
        <input style={s.input} placeholder="🔍 Buscar por nombre, cédula o teléfono..." value={buscar} onChange={e => setBuscar(e.target.value)} />
        <select style={s.select} value={estado} onChange={e => setEstado(e.target.value)}>
          <option value="">Todos los estados</option>
          <option value="activo">Activo</option>
          <option value="moroso">Moroso</option>
          <option value="suspendido">Suspendido</option>
          <option value="inactivo_temporal">Inactivo temporal</option>
          <option value="retirado">Retirado</option>
        </select>
        <select style={s.select} value={planId} onChange={e => setPlanId(e.target.value)}>
          <option value="">Todos los planes</option>
          {planes.map(p => <option key={p.id} value={p.id}>{p.nombre}</option>)}
        </select>
        {Object.keys(enviados).length > 0 && (
          <button style={s.btnLimpiar} onClick={reiniciarMarcados}>Quitar marcas de enviado</button>
        )}
      </div>

      <div style={s.resumen}>
        {cargando ? 'Cargando...' : (
          <>
            <b>{conTelefono.length}</b> cliente{conTelefono.length !== 1 ? 's' : ''} con teléfono para escribir
            {sinTelefono > 0 && <span style={s.avisoSinTel}> · {sinTelefono} sin teléfono registrado (no se pueden contactar)</span>}
            {Object.keys(enviados).length > 0 && <span> · {Object.keys(enviados).length} marcados como enviados en esta sesión</span>}
          </>
        )}
      </div>

      <div style={s.tabla}>
        <table style={s.table}>
          <thead>
            <tr style={s.thead}>
              <th style={s.th}>Cliente</th>
              <th style={s.th}>Teléfono</th>
              <th style={s.th}>Plan</th>
              <th style={s.th}>Estado</th>
              <th style={s.th}>Acción</th>
            </tr>
          </thead>
          <tbody>
            {clientes.length === 0 ? (
              <tr><td colSpan={5} style={s.vacio}>{cargando ? 'Cargando...' : 'No hay clientes con estos filtros'}</td></tr>
            ) : clientes.map(c => {
              const tel = formatearTelefono(c.telefono);
              return (
                <tr key={c.id} style={s.tr}>
                  <td style={s.td}>{c.nombre}</td>
                  <td style={s.td}>{c.telefono || <span style={s.sinDato}>Sin registrar</span>}</td>
                  <td style={s.td}>{c.plan_nombre || <span style={s.sinDato}>Sin plan</span>}</td>
                  <td style={s.td}><span style={s.estadoBadge}>{c.estado}</span></td>
                  <td style={s.td}>
                    {tel ? (
                      <button style={enviados[c.id] ? s.btnEnviado : s.btnEnviar} onClick={() => enviar(c)}>
                        {enviados[c.id] ? '✓ Enviado' : '📲 Enviar'}
                      </button>
                    ) : <span style={s.sinDato}>Sin teléfono</span>}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </Layout>
  );
}

const s = {
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '12px', marginBottom: '20px' },
  titulo: { fontSize: '24px', fontWeight: '700', marginBottom: '4px' },
  sub: { color: 'rgba(255,255,255,0.4)', fontSize: '14px' },
  panel: { background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '14px', padding: '18px', marginBottom: '16px' },
  label: { display: 'block', fontSize: '13px', color: 'rgba(255,255,255,0.6)', marginBottom: '8px' },
  textarea: { width: '100%', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.12)', borderRadius: '10px', padding: '12px 14px', color: '#fff', fontSize: '14px', fontFamily: 'inherit', outline: 'none', resize: 'vertical', lineHeight: '1.5' },
  preview: { marginTop: '14px', background: 'rgba(16,185,129,0.06)', border: '1px solid rgba(16,185,129,0.2)', borderRadius: '10px', padding: '12px 14px' },
  previewLabel: { fontSize: '11px', fontWeight: '700', color: '#6EE7B7', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '6px' },
  previewTexto: { fontSize: '13px', color: 'rgba(255,255,255,0.75)', whiteSpace: 'pre-wrap', lineHeight: '1.6' },
  filtros: { display: 'flex', gap: '10px', marginBottom: '14px', flexWrap: 'wrap' },
  input: { flex: '2 1 260px', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '10px', padding: '10px 14px', color: '#fff', fontSize: '14px', outline: 'none' },
  select: { flex: '1 1 160px', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '10px', padding: '10px 14px', color: '#fff', fontSize: '14px', outline: 'none', cursor: 'pointer' },
  btnLimpiar: { background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '10px', padding: '10px 14px', color: 'rgba(255,255,255,0.6)', fontSize: '13px', cursor: 'pointer' },
  resumen: { fontSize: '13px', color: 'rgba(255,255,255,0.5)', marginBottom: '12px' },
  avisoSinTel: { color: '#FCD34D' },
  tabla: { background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '16px', overflow: 'hidden' },
  table: { width: '100%', borderCollapse: 'collapse' },
  thead: { background: 'rgba(255,255,255,0.04)' },
  th: { padding: '12px 16px', textAlign: 'left', fontSize: '12px', color: 'rgba(255,255,255,0.4)', fontWeight: '600', letterSpacing: '0.5px', textTransform: 'uppercase' },
  tr: { borderTop: '1px solid rgba(255,255,255,0.05)' },
  td: { padding: '12px 16px', verticalAlign: 'middle', fontSize: '13.5px' },
  vacio: { padding: '40px', textAlign: 'center', color: 'rgba(255,255,255,0.3)', fontSize: '14px' },
  sinDato: { color: 'rgba(255,255,255,0.25)', fontSize: '12.5px' },
  estadoBadge: { fontSize: '12px', fontWeight: '600', padding: '3px 10px', borderRadius: '20px', background: 'rgba(255,255,255,0.06)', textTransform: 'capitalize' },
  btnEnviar: { background: 'linear-gradient(135deg,#25D366,#128C7E)', border: 'none', borderRadius: '8px', padding: '7px 14px', color: '#fff', fontSize: '12.5px', fontWeight: '600', cursor: 'pointer', whiteSpace: 'nowrap' },
  btnEnviado: { background: 'rgba(16,185,129,0.1)', border: '1px solid rgba(16,185,129,0.3)', borderRadius: '8px', padding: '7px 14px', color: '#6EE7B7', fontSize: '12.5px', fontWeight: '600', cursor: 'pointer', whiteSpace: 'nowrap' },
};
